import * as Types from "../../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchRegionsQueryVariables = Types.Exact<{
  practiceId: Types.Scalars["ID"]["input"];
}>;

export type FetchRegionsQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    regions?: {
      __typename?: "SearchRegionConnection";
      nodes: Array<{
        __typename?: "SearchRegion";
        id: string;
        name?: string | null;
        slug?: string | null;
      }>;
    } | null;
  } | null;
};

export const FetchRegionsDocument = gql`
  query FetchRegions($practiceId: ID!) {
    practice(id: $practiceId) {
      id
      regions {
        nodes {
          id
          name
          slug
        }
      }
    }
  }
`;

/**
 * __useFetchRegionsQuery__
 *
 * To run a query within a React component, call `useFetchRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRegionsQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useFetchRegionsQuery(
  baseOptions: Apollo.QueryHookOptions<FetchRegionsQuery, FetchRegionsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<FetchRegionsQuery, FetchRegionsQueryVariables>(
    FetchRegionsDocument,
    options,
  );
}
export function useFetchRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchRegionsQuery, FetchRegionsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<FetchRegionsQuery, FetchRegionsQueryVariables>(
    FetchRegionsDocument,
    options,
  );
}
export type FetchRegionsQueryHookResult = ReturnType<typeof useFetchRegionsQuery>;
export type FetchRegionsLazyQueryHookResult = ReturnType<typeof useFetchRegionsLazyQuery>;
export type FetchRegionsQueryResult = Apollo.QueryResult<
  FetchRegionsQuery,
  FetchRegionsQueryVariables
>;
